import 'lazysizes'

window.$ = window.jQuery = require('jquery')

require('bootstrap')

require('@fancyapps/fancybox')